import AllocatableWorker from '@/entity/AllocatableWorker';
import BusinessError from '@/error/BusinessError';
import { i18n } from '@/locales';
import { getCalcDistance } from '@/utils/etc';
import { formatPhoneNumber } from '@/utils/regularExpression';
import attendCode from '@/constants/attendCode';
export default class AllocatableWorkerVM extends AllocatableWorker {
    // eslint-disable-next-line no-useless-constructor
    constructor(worker) {
        super(worker);
    }
    get workerAttendCode() {
        return i18n.t(attendCode[this.workerAttend]?.text);
    }
    get isDeniedStoreToString() {
        return this.isDeniedStore ? 'Y' : 'N';
    }
    get workerPhoneWithHyphen() {
        return formatPhoneNumber(this.workerPhone);
    }
    /** 상점과 라이더의 거리 */
    get getDistanceFromPickupWithKm() {
        if (Number.isNaN(this.distanceFromPickup) || this.distanceFromPickup > 999) {
            return '-';
        }
        // 0.01보다 작으면 반올림 (10m 이하는 10m로 표기)
        if (this.distanceFromPickup < 0.01) {
            return '0.00km';
        }
        return `${this.distanceFromPickup.toFixed(2)}km`;
    }
    /** 도착지와 라이더의 거리 */
    getDistanceCustomer({ dropLat, dropLong, }) {
        return getCalcDistance(Number(this.workerLocation?.latitude), Number(this.workerLocation?.longitude), Number(dropLat), Number(dropLong));
    }
    /**
     * 공유 워커 여부
     * 내 허브와 라이더 허브가 다르면 공유라이더
     * AllocatableWorker 에서는 타총판 라이더가 나오지 않기에 허브만 판단하면 된다.
     * @param targetId 허브 아이디 (Bxxxx)
     * @returns
     */
    isShareWorker(targetId) {
        if (!targetId) {
            throw new BusinessError('[isShareWorker] targetId is required');
        }
        return targetId !== this.hubId;
    }
}
